import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPriceAlert1 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 209 73" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#007AFF"
        d="m0 25.99 39.484 4.76 39.184-15.368 39.716 5.789 39-20.171 50.562 71.132"
      />
      <g transform="translate(166 19)">
        <circle cx={17.5} cy={17.5} r={17.5} fill="#A2E9C6" opacity={0.3} />
        <g stroke="#17181A" transform="rotate(10 -35.144 69.307)">
          <path
            fill="#FFF"
            d="M7.436 2.25c-2.68.164-4.098 1.746-4.257 4.745-.159 2.999-1.05 4.832-2.673 5.5-.605.562-.605 1.024 0 1.386.908.543 3.604 1.176 6.93 1.176h.07c3.326 0 6.022-.633 6.93-1.176.605-.362.605-.824 0-1.387-1.623-.667-2.514-2.5-2.673-5.5-.16-2.998-1.578-4.58-4.257-4.745h-.07z"
          />
          <path
            fill="#FFF"
            d="M5.04 15.011a2.932 2.932 0 0 0-.076.707 2.482 2.482 0 1 0 4.963 0 2.91 2.91 0 0 0-.104-.739c-.755.082-1.547.123-2.378.123-.83 0-1.632-.03-2.405-.09z"
          />
          <circle cx={7.445} cy={0.827} r={1} />
        </g>
      </g>
    </g>
  </svg>
);
const Memo = memo(SvgPriceAlert1);
export default Memo;
